//BASE Url
export const BASE_URL: string = 'api/SetupFamily'

export class FamilyVM {
  Id: number
  Title: string
  Symbol: string
  ExistingCount: number
  Blob_auto: number
}

export class blobFamilyImageVM {
  fileName: string
  image: string
  blob_auto: number
}
export class FamilyDetailsVM {
  type_auto: number
  typeid: string
  typedesc: string
  created_date: Date
  createdUser: string
  modified_date: Date
  modifieduser: string
  blob_auto: number
  ChainImage: string
  FrameImage: string
  ShowDistTravelledTracking: boolean
  ShowPropelHrsPerc: boolean
  ShowEqualiserBarType: boolean
  ShowTrackIntensionIndicator: boolean
  ShowFrameConfiguration: boolean
  ShowCannonType: boolean
  ShowBogieShim: boolean
  ShowManualInspection: boolean
  ShowTrackSag: boolean;
  ShowCannonExt: boolean;
  ShowScallop: boolean;
  ShowDryJoints: boolean;
  ShowNumberOfLinks: boolean;
  ShowUnderFootConditions: boolean;
  ShowWorkOrder: boolean;
  ShowThermalImage: boolean;
  ShowAdditionalInspectors: boolean;
  IsConditon: boolean;
  ShowIsometricViews: boolean;
}
export class UserVM {
  userid: string
}
